<template>
    <v-flex xl12>
        <h2>Visão geral<span class="text-title-header"> | Overview </span></h2>
        <v-divider></v-divider>
         <v-card flat>
            <v-container fluid grid-list-lg>
                <v-layout row wrap>
                    <v-flex sm12 lg4>
                        <v-card color="blue" flat>
                            <v-container fill-heightfluid pa-3>
                                <v-layout fill-height>
                                    <v-flex xs12 align-end flexbox>
                                        <span class="headline white--text"><b>Última atualização com Vista</b> <br/> {{overview.config.last_update}}</span>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card>
                    </v-flex>

                    <v-flex sm12 lg4>
                        <v-card color="green" flat>
                            <v-container fill-heightfluid pa-3>
                                <v-layout fill-height>
                                    <v-flex xs12 align-end flexbox>
                                        <span class="headline white--text"><b>{{overview.sale}}</b> <br/>  Imóveis para venda</span>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card>
                    </v-flex>

                    <v-flex sm12 lg4>
                        <v-card color="orange" flat>
                            <v-container fill-heightfluid pa-3>
                                <v-layout fill-height>
                                    <v-flex xs12 align-end flexbox>
                                        <span class="headline white--text"><b>{{overview.rental}}</b>  <br/> Imóveis para locação</span>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card>
                    </v-flex>

                </v-layout>
            </v-container>
        </v-card>

        <v-divider></v-divider>

        <v-flex xs12 sm12>
            <v-card flat>
                <v-container fluid grid-list-md>
                    <v-layout row wrap>
                        <span class="headline">Últimas dicas</span>
                        <v-flex xs12 sm12>
                            <div v-for="(item, index) in news" :key="index" style="width: 200px;float: left;padding: 5px;">
                                <td>
                                    <v-img :src="item.poster" :lazy-src="item.poster" aspect-ratio="2" class="grey lighten-2"></v-img>
                                    {{item.created}} - {{item.title}}
                                </td>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
        </v-flex>

        <v-divider></v-divider>

        <v-flex xs12 sm12>
            <v-card flat>
                <v-container fluid grid-list-md>
                    <v-layout row wrap>
                        <span class="headline">Banners</span>
                        <v-flex xs12 sm12>
                            <div v-for="(item, index) in banners" :key="index" style="width: 200px;float: left;padding: 5px;">
                               <v-img :src="item.path" :lazy-src="item.path" aspect-ratio="2" class="grey lighten-2"></v-img>
                               {{item.created}} - {{item.title}}
                            </div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
        </v-flex>

    </v-flex>
</template>
<script>
    export default {
        name: 'overview',
        data: () => ({
            overview:{
                rental:'',
                sale:'',
                config:{
                    last_update:''
                }
            },
            survey:{},
            banners:[],
            news:[],
            loading: false
        }),
        mounted: function () {
            this.$nextTick(function () {
                this.getOverviewFromApi()
                this.getBannersFromApi()
                this.getNewsFromApi()
            })
        },
        methods:{
            getSurvey() {
                var self = this
                self.axios.get('/get-nota.json',{
                    headers: {
                        'Authorization': self.$store.state.token
                    }
                }).then((response) => {
                    self.survey = response.data
                })
            },
            getOverviewFromApi() {
                var self = this
                self.loading = true
                self.axios.get('/get-overview.json',{
                    headers: {
                        'Authorization': self.$store.state.token
                    }
                }).then((response) => {
                    self.$store.commit('setLoading', false)
                    self.overview = response.data
                    self.loading = false
                    self.getSurvey()
                })
            },
            getBannersFromApi() {
                var self = this
                self.axios.get('/list-banners.json', {
                    headers: {
                        'Authorization': self.$store.state.token
                    }
                }).then((response) => {
                    self.$store.commit('setLoading', false)
                    self.banners = response.data.registries
                })
            },
            getNewsFromApi() {
                var self = this
                self.axios.get('/list-news.json', {
                    headers: {
                        'Authorization': self.$store.state.token
                    }
                }).then((response) => {
                    self.$store.commit('setLoading', false)
                    self.news = response.data.registries
                })
            }
        }
    }
</script>
